import React from "react";

interface BadgeProps {
  children: React.ReactNode;
  className?: string;
}

export default function Badge({ children, className = "" }: BadgeProps) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-1 text-xs font-medium bg-white/80 dark:bg-soft-black/80 backdrop-blur border-light-gray-alt dark:border-deep-purple/50 ${className}`}>
      {children}
    </span>
  );
}